module.exports = __webpack_public_path__ + "static/000678-e67475cfa841b1401cab57a7222c6ee1.jpg";